import React from 'react'
import ComplaintListComponent from '../Components/Complaint/ComplaintListComponent'

function ComplaintPage() {
    return (
        <ComplaintListComponent/>
    )
}

export default ComplaintPage